import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { BankReconciliationRow } from "../bankReconciliationViewConfig";

export const EntityCell = ({
    row,
}: CellContext<ViewTableFeatures, BankReconciliationRow, unknown>) => {
    const entity = row.original.entity;
    const isReconciliationRow = !!row.original.bankReconciliation;

    if (isReconciliationRow || !entity) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <AvatarTooltip content={entity.name}>
                <EntityAvatar entity={entity} size="xs" />
            </AvatarTooltip>
        </ViewTableCell>
    );
};
